// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { useSbdSeriesData } from "./sbdSeriesData";

export const useSbdSeriesDataById = (inputSeries?: any[]) => {
  const seriesDataById: any = {};

  const seriesData: any[] = inputSeries ?? useSbdSeriesData();

  for (const [key, value] of seriesData.entries()) {
    seriesDataById[value.key] = value;
  }

  return seriesDataById;
};
